import { getDisabledMembers } from 'pages/AffordaWagesAndIncome/utils';
import {
  FIELD_MEMBERS,
  WAGES_AND_INCOME_COMMON_FIELD_NAMES,
} from './constants.fields';

export const MAX_RECORDS_BY_USER = 1;

export const NEW_RECORD = {
  memberId: '',
  monthlyAmount: '0',
};

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.benefitsRental.title',
  description: 'afforda.wagesAndIncome.details.benefitsRental.subtitle',
  addButton: 'afforda.wagesAndIncome.details.benefitsRental.add',
  addCaption: 'afforda.wagesAndIncome.details.benefitsRental.addDescription',
};

export const BENEFITS_RENTAL_FIELD_NAMES = {
  id: 'id',
  memberId: WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    [BENEFITS_RENTAL_FIELD_NAMES.id]: item.id,
    [BENEFITS_RENTAL_FIELD_NAMES.monthlyAmount]: item.monthlyAmount ?? '',
  };
};

export const getFormProps = ({ items, memberId }) => {
  return {
    disabledMembers: getDisabledMembers(items, memberId, MAX_RECORDS_BY_USER),
  };
};

export const FIELDS = ({ members, disabledMembers }) => {
  return [...FIELD_MEMBERS({ members, disabledMembers })];
};
